module.exports = __webpack_public_path__ + "img/logo-only.7643e7de.png";